export enum SHIFT_STATUS_TYPES {
    DRAFT = 'Draft',
    SCHEDULED = 'Scheduled',
    PENDING = 'Pending',
    COMPLETED = 'Completed',
    NO_SHOW = 'No show',
    CANCELED = 'Canceled',
  }